// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"267":"22c826a1dc0e174cfbe8","926":"90c63f89bf5aaf79313b"}[chunkId] + ".chunk.js";
};